// extracted by mini-css-extract-plugin
module.exports = {"absoluteLoader":"Loader_absoluteLoader__1iN37"};